import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs/internal/Observable';
import {
  Country,
  CountryIsoNumberToAlpha3CodeMap,
  GetAutopayStatusResponse,
  EnableAutopayV1Request,
  DisableAutopayV1Request,
  GetBankHolidayScheduleResponseV1,
  AutopayEligibilityResponse,
} from '../models';
import { PaymentSchedulerService } from './payment-scheduler.service';

export class PaymentSchedulerPlatformService extends PaymentSchedulerService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  public getBankHolidayScheduleV1(
    tenantId: string,
    country: Country,
  ): Observable<GetBankHolidayScheduleResponseV1> {
    const countryCode = CountryIsoNumberToAlpha3CodeMap.get(country);
    return this.httpClient.get<GetBankHolidayScheduleResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/bank/holidayschedule?country=${countryCode}`,
    );
  }

  public getCutoffTimeScheduleV1(
    tenantId: string,
    version: string,
  ): Observable<string> {
    return this.httpClient.get<string>(
      `${this.baseUrl}/v1/tenants/${tenantId}/ach/versions/${version}/cutofftime`,
    );
  }

  public getAutopayStatusV1(tenantId: string, accountNumber: string) {
    return this.httpClient.get<GetAutopayStatusResponse>(
      `${this.baseUrl}/v1/tenants/${tenantId}/accounts/${accountNumber}/autopaymentinstruction`,
    );
  }

  public enableAutopayV1(
    tenantId: string,
    accountNumber: string,
    request: EnableAutopayV1Request,
  ) {
    return this.httpClient.put<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/accounts/${accountNumber}/autopaymentinstruction`,
      request,
    );
  }

  public disableAutopayV1(
    tenantId: string,
    accountNumber: string,
    request: DisableAutopayV1Request,
  ) {
    return this.httpClient.delete<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/accounts/${accountNumber}/autopaymentinstruction`,
      { body: request },
    );
  }

  public getAutopayEligibilityV1(tenantId: string, accountNumber: string) {
    return this.httpClient.get<AutopayEligibilityResponse>(
      `${this.baseUrl}/v1/tenants/${tenantId}/accounts/${accountNumber}/autopaymenteligibility`,
    );
  }
}
